import React, { FC } from 'react';
import { PartsResetConfirmDialog } from '@component/Dialog';
import { useDialogState } from '@app/react/hooks/useDialogState';

export const KEY = 'shaft-reset-otherparts';

export const PartsResetConfirmDialogContainer: FC = () => {
    const { showDialog, okHandler, cancelHandler } = useDialogState(KEY);

    return (
        <PartsResetConfirmDialog
            show={showDialog}
            btnChangeProps={{
                onClick: okHandler,
            }}
            btnNochangeProps={{
                onClick: cancelHandler,
            }}
            title="ご注意"
            description={(
                <>
                    ただいま選択したシャフトに変更すると
                    選択中の「筈」「矢尻」「インサート」が破棄され再選択する必要があります。
                    <br />
                    シャフトを変更しますか？
                </>
            )}
        />
    );
};
